import { useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { v4 as uuidv4 } from 'uuid';
import { useCoupangApiStoreInfoActionsContextHook } from '../../../../contexts/CoupangApiStoreInfoContext';
import { CoupangApiApi } from '../../../../../../../apis/CoupangApiApi';
import * as St from './index.styled';

export function AddCoupangApiStoreInfoModal({
    open,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const coupangApiStoreInfoActionsContextHook = useCoupangApiStoreInfoActionsContextHook();
    // 필요한 로컬 상태나 로직
    // ex) API 입력값 등
    const [formData, setFormData] = useState({
        id: uuidv4(),
        storeName: "",
        vendorCode: '',
        accessKey: '',
        secretKey: '',
    });

    const handleSave = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        const addResult = await CoupangApiApi().addCoupangApiStoreInfos({ headers: headers, body: { coupangApiStoreInfos: [{ ...formData }] } })

        if (addResult?.content) {
            coupangApiStoreInfoActionsContextHook.coupangApiStoreInfos.onSet(addResult?.content);
        }

        onClose(false);
    }

    return (
        <CustomDialog
            open={open}
            onClose={() => onClose(false)}
        >
            {/* Header 부분 */}
            <St.ModalHeader>
                <CustomDialog.Header.Fake />
                <CustomDialog.Header.Title>스토어 API 추가</CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose(false)} />
            </St.ModalHeader>

            {/* Body 부분 예시 */}
            <St.ApiAddModalBody>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.storeName}
                        onChange={(e) => setFormData({ ...formData, storeName: e.target.value })}
                    />
                    <CustomLabelInput.Label>스토어명</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.vendorCode}
                        onChange={(e) => setFormData({ ...formData, vendorCode: e.target.value })}
                    />
                    <CustomLabelInput.Label>Vendor Code</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.accessKey}
                        onChange={(e) => setFormData({ ...formData, accessKey: e.target.value })}
                    />
                    <CustomLabelInput.Label>Access Key</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.secretKey}
                        onChange={(e) => setFormData({ ...formData, secretKey: e.target.value })}
                    />
                    <CustomLabelInput.Label>Secret Key</CustomLabelInput.Label>
                </CustomLabelInput>

                <div className="buttons">
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose(false)}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='primary'
                        onClick={handleSave}
                    >
                        저장
                    </CustomBlockButton>
                </div>
            </St.ApiAddModalBody>
        </CustomDialog>
    );
}